import { render, staticRenderFns } from "./WeightsViewDialog.vue?vue&type=template&id=06b36ca4&"
import script from "./WeightsViewDialog.vue?vue&type=script&lang=js&"
export * from "./WeightsViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports